import React, { useState } from "react";
import axios from "axios";
import "./SignupPage.css"; // for styling
import loginBg from "../assets/history2/Classical_Antiquity_-_Han_Dynasty_China.png";
import { useNavigate } from "react-router-dom";
import api from '../api'; // ensures interceptors are installed

export default function LoginPage() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = e => {
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError("");

    try {
      // 1) Obtain JWT tokens
      //const { data } = await axios.post(
      const { data } = await api.post(
        `${process.env.REACT_APP_API_URL}/api/token/`,
        {
          username: form.email,
          password: form.password,
        }
      );

      // 2) Store them (you can use localStorage, secure cookie, etc.)
      localStorage.setItem("access_token", data.access);
      localStorage.setItem("refresh_token", data.refresh);

      // 3) Tell axios to send the access token on every request
      //axios.defaults.headers.common["Authorization"] = `Bearer ${data.access}`;

      // 4) Navigate to your protected page
      navigate("/campfirepage");
    } catch (err) {
      console.error("Login error", err);
      if (err.response?.status === 401) {
        setError("Invalid credentials.");
      } else {
        setError("Login failed. Please try again.");
      }
    }
  };

  return (
    <div
      className="signup-container"
      style={{ backgroundImage: `url(${loginBg})` }}
    >
      <div className="signup-header">
        <a href="/Home" className="signup-header-btn">Home</a>
        <a href="/signup" className="signup-header-btn">Sign Up</a>
      </div>

      <form className="signup-form" onSubmit={handleSubmit}>
        <h2>Log In</h2>
        {error && <div className="error-msg">{error}</div>}

        <label>
          Email
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          Password
          <input
            type="password"
            name="password"
            value={form.password}
            onChange={handleChange}
            required
          />
        </label>

        <button type="submit" className="btn-submit">Log In</button>
        <p><a href="/forgot-password">Forgot Password?</a></p>
      </form>
    </div>
  );
}
